import HCaptcha from '@hcaptcha/react-hcaptcha';
import React, { FC, useRef, useState } from 'react';
import { parse } from 'qs';
import { Button, Form, Grid } from '../../kit';
import api from '../../api';
import { ApiCoach } from '../../models/Coach';
import styles from './styles.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSmile } from '@fortawesome/pro-regular-svg-icons';

const RegisterView: FC<{ title: string }> = ({ title }): JSX.Element => {
    const [ coach, setCoach ] = useState<Partial<ApiCoach>>({});
    const [ errors, setErrors ] = useState<any>({});
    const [ password, setPassword ] = useState<string>('');
    const [ showCaptcha, setShowCaptcha ] = useState<boolean>(false);
    const [ success, setSuccess ] = useState<boolean>(false);
    const captchaToken = useRef<string>('');
    const captchaEkey = useRef<string>('');

    const handleInput = ({ name, value }: any): void => {
        setCoach((c) => ({
            ...c,
            [name]: value,
        }));
        setShowCaptcha(true);
    }

    const register = (): void => {
        setErrors({});

        api.register(coach, password, {
            ekey: captchaEkey.current,
            token: captchaToken.current,
        }).then(() => {
            setSuccess(true);
        }).catch((err) => {
            setErrors(err.response.data.errors);
        });
    }

    return (
        <div className={styles.registerForm}>
            {success ? (
                <div className={styles.success}>
                    <FontAwesomeIcon icon={faSmile} />
                    <p>Je aanmelding is gelukt!</p>
                </div>
            ) : (<>
                <h3>{title}</h3>
                <Grid.Row style={{ marginBottom: 16 }}>
                    <Grid.Column lg={4}>
                        <Form.Input
                            error={errors.firstName}
                            label="Voornaam"
                            name="first_name"
                            onChange={handleInput}
                            required
                            value={coach.first_name}
                        />
                    </Grid.Column>
                    <Grid.Column lg={3} style={{ padding: 0 }}>
                        <Form.Input
                            label="Tussenvoegsel"
                            name="affix"
                            onChange={handleInput}
                            value={coach.affix}
                        />
                    </Grid.Column>
                    <Grid.Column lg={5}>
                        <Form.Input
                            error={errors.lastName}
                            label="Achternaam"
                            name="last_name"
                            onChange={handleInput}
                            required
                            value={coach.last_name}
                        />
                    </Grid.Column>
                </Grid.Row>
                <Form.Input
                    error={errors.emailAddress}
                    label="E-mailadres"
                    name="email_address"
                    onChange={handleInput}
                    required
                    type="email"
                    value={coach.email_address}
                />
                <Form.Input
                    error={errors.password}
                    label="Wachtwoord"
                    name="password"
                    onChange={({ value }: any) => setPassword(value)}
                    required
                    type="password"
                    value={password}
                />
                {showCaptcha && (
                    <Form.Group style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <HCaptcha
                            sitekey={process.env.REACT_APP_HCAPTCHA_KEY || ''}
                            onVerify={(token, ekey) => {
                                captchaToken.current = token;
                                captchaEkey.current = ekey;
                            }}
                        />
                    </Form.Group>
                )}
                <div className={styles.buttons}>
                    <Button
                        color="primary"
                        label="Aanmelden"
                        onClick={() => register()}
                    />
                </div>
            </>)}
        </div>
    );
}

export default RegisterView;
